module.exports = __webpack_public_path__ + "static/media/ic-undo.01e052c7.svg";